<template>
  <div :class="`post-header ${isRepost ? 'post-header--repost' : ''}`">
    <div class="post-source">
      <a :href="post.author_url ? post.author_url : '#'" target="_blank" class="post-source__img-wrap" rel="noreferrer">
        <img :src="post.author_logo" alt="" class="post-source__img" v-if="post.author_logo" referrerpolicy="no-referrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" x="0px" y="0px" viewBox="0 0 70 70" class="post-source__img" v-if="!post.author_logo" >
          <circle cx="35" cy="35" r="35" fill="#EEEEEE"/>
          <path d="M53.74939,48.28949c-0.75598-0.74872-1.77271-1.65887-2.26318-2.14459 c-2.63391-2.22192-5.73602-3.92212-9.1308-4.92682c4.1167-2.47296,6.88708-6.97467,6.88708-12.09467 C49.24249,21.31781,42.86273,15,34.98053,15s-14.26215,6.33722-14.26215,14.12341c0,5.12,2.75104,9.6217,6.88721,12.09467 c-3.35577,1.0047-6.41888,2.68561-9.03326,4.86884c-0.29785,0.29486-0.70184,0.50177-2.34125,2.12531 c-2.80945,3.01398-4.89709,6.72357-5.97015,10.81958l-0.10785,0.61395C16.49463,66.03876,25.28387,70,35,70 c9.68921,0,18.4577-3.93823,24.79517-10.29999l-0.13409-0.66821C58.58801,54.95508,56.53943,51.30353,53.74939,48.28949z" fill="#BBBBBB"/>
        </svg>
          <div class="post-body__additional">
            <img src="../../../../../../../assets/img/vk-icon.svg" width="16px" v-if="post.network_name === 'vk'">
            <img src="../../../../../../../assets/img/dz-icon.svg" width="16px" v-if="post.network_name === 'dz'">
            <img src="../../../../../../../assets/img/ok-icon.svg" width="16px" v-if="post.network_name === 'ok'">
            <img src="../../../../../../../assets/img/twitter.svg" width="16px" v-if="post.network_name === 'tw'">
            <img src="../../../../../../../assets/img/telegram.svg" width="16px" v-if="post.network_name === 'tg'">
            <img src="../../../../../../../assets/img/facebook.svg" width="16px" v-if="post.network_name === 'fb'">
            <img src="../../../../../../../assets/img/ig.png" width="16px" v-if="post.network_name === 'ig'">
            <img src="../../../../../../../assets/img/gs.svg" width="16px" v-if="post.network_name === 'gs'">
            <img src="../../../../../../../assets/img/yt.png" width="18px" v-if="post.network_name === 'yt'">
          </div>
      </a>

      <div class="post-source__info">
        <div class="flex">
        <a :href="post.author_url ? post.author_url : '#'" target="_blank" class="post-source__title">
          {{post.author ? post.author : 'Не определен'}}
        </a>
            <span class="post-info-panel__item to-ex" style="font-size: 12px;font-weight: bold;margin-left: 20px;" v-if="this.excluded == !post.id" @click="addExSource(post)">{{$t('post.postInfoPanel.excludeSource')}}</span>
            <span class="post-info-panel__item to-ex" style="font-size: 12px;font-weight: bold;margin-left: 20px;" v-if="this.excluded == post.id" >Источник будет исключен из выдачи</span>
        </div>
        <div class="flex">
          <a :href="post.uri" target="_blank" class="post-source__date">
            {{getDate(post.created_date)}} 
          </a>  
        <div v-if="info" style="display: flex; margin-left: 5px;">
          <span style="font-size: 9px; padding-right: 10px" v-for="item in post.location" :key="item" @click="showDeliteInfo(item)">
            {{item}}
            <el-tooltip effect="light" content="Удалить локацию поста" placement="right" :key="post.id">
              <img src="../../../../../../../assets/img/trash.svg" @click="showDeliteInfo(item)" class="edit" width="10px" style="padding-top: 3px; padding-left: 0px">
            </el-tooltip>
          </span>
          <el-tooltip effect="light" content="Добавить локацию поста" placement="right" :key="post.id">
            <img src="../../../../../../../assets/img/plus.svg" @click="showEditInfo()" class="edit" width="16px" v-if="!isRepost">
          </el-tooltip>
        </div>
        </div>
      </div>
    </div>

    <div class="post-social">
      <ul class="post-social-list">
        <li v-if="post.network_id != '4' && post.engagementrate" class="post-social-list__item">
          <img src="../../../../../../../assets/img/reaction.svg" alt="">
          {{Math.round(post.engagementrate)}}%
        </li>
        <li v-if="post.network_id != '4' && post.viewed != 0 && !post.engagementrate" class="post-social-list__item">
          <img src="../../../../../../../assets/img/reaction.svg" alt="">
          {{Math.ceil((+post.likes / +post.viewed) *100) + "%"}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/favorite.svg" alt="">
          {{post.likes}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/reply.svg" alt="">
          {{post.reposts}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/mode_comment.svg" alt="">
          {{post.comments}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/visibility.svg" alt="">
          {{post.viewed}}
        </li>
        <li class="post-social-list__item">
          <img src="../../../../../../../assets/img/people.svg" style="width: 15px" alt="">
          {{post.attendance}}
        </li>
      </ul>
    </div>
    <el-dialog
      title="Добавить локацию поста"
      :visible.sync="dialogEditInfo"
    >
      <p>Выполните поиск нужного значения:</p>
      <el-input v-model="searchString" @input.native="onChange" :class="inputClass" placeholder="Поиск">
        <el-button @click="onSelect" slot="append" type="primary">
          <i class="material-icons">
            search
          </i>
        </el-button>
      </el-input>
      <div v-if="showSelect">
        <p>Выберите подходящий вариант на основе поиска:</p>
          <el-select v-model="selectString" class="el-input-group">
            <el-option
              v-for="item in gridData"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
      </div>
      <p v-if="showCheckbox && !showSelect" style="color: #409EFF">Поиск не дал результатов</p>
      <p>Если подходящего варианта не найдено, можно добавить новое значение:</p>
      <el-checkbox :disabled="!showCheckbox" v-model="notDefined" label="Нет подходящего варианта"></el-checkbox>
      <br>
      <el-button @click="onReset" v-if="!notDefined" :disabled="selectString.length < 2" type="primary" style="margin: 10px 0">
        Добавить локацию {{selectString}}
      </el-button>
      <br>
      <el-button @click="onReset" v-if="notDefined" :disabled="searchString.length < 2" type="primary" style="margin: 10px 0">
        Добавить локацию {{searchString}}
      </el-button>
    </el-dialog>
    <el-dialog
      title="Удалить локацию поста"
      :visible.sync="dialogDeliteInfo"
    >
    <p>Вы уверены, что хотите удалить локацию "{{currentString}}" ?</p>

      <el-button @click="onDelite" type="primary" style="margin: 10px 0">
        Удалить локацию 
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { addStopSourcesApi } from "../../../../../../../api/feeds";
import { getSentimentAutocompleteApi, updatePostSentimentApi, removePostSentimentApi } from "../../../../../../../api/publications";

  export default {
    name: 'PostHeader',
    props: {
      post: {
        type: Object
      },
      isRepost: {
        type: Boolean
      },
      info: {
        type: Boolean
      }
    },
    data() {
      return {
        excluded: 0,
        dialogEditInfo: false,
        dialogDeliteInfo: false,
        gridData: {},
        showCheckbox: false,
        searchString: "",
        selectString: "",
        currentString: "",
        showSelect: false,
        notDefined: false
      }
    },
    computed: {
      inputClass() {
        return this.error ? "input-with-select input-with-select--error" : "input-with-select";
      }
    },
    methods: {
      showEditInfo() {
        this.dialogEditInfo = true;
      },

      showDeliteInfo(value) {
        this.dialogDeliteInfo = true;
        this.currentString = value
      },

    onChange(event) {
      this.searchString = event.target.value;
      this.showSelect = false
      this.showCheckbox = false
      this.notDefined = false
      this.selectString = ""
    },

    onSelect() {
      if (this.searchString.length > 2)
        {
        
        this.loading = true;
        let params = {
          type: "location",
          search: this.searchString
        };

        getSentimentAutocompleteApi(params)
          .then((resp) => {
            this.showCheckbox = true
            if (resp.data[0]) this.showSelect = true;
            console.log("resp", resp)
            
            this.gridData = {...resp.data};
            this.loading = false;
          })
          .catch((this.loading = true));}
    },
    onReset() {
      this.loading = true;
        let params = {
          post_id: this.post.inner_id,
          network_id: this.post.network_id,
          type: "location",
          value: this.notDefined ? this.searchString : this.selectString
        };
        updatePostSentimentApi(params)
          .then((resp) => {
            this.showCheckbox = true
            if (resp.data[0]) this.showSelect = true;
            this.dialogEditInfo = false;
            this.loading = false;
            this.$emit('loadPosts')
          })
          .catch((this.loading = true));
    },
    onDelite() {
      this.loading = true;
        let params = {
          post_id: this.post.inner_id,
          network_id: this.post.network_id,
          type: "location",
          value: this.currentString
        };
        removePostSentimentApi(params)
          .then((resp) => {
            if (resp.data[0]) this.showSelect = true;
            this.dialogDeliteInfo = false;
            this.loading = false;
            this.$emit('loadPosts')
          })
          .catch((this.loading = true));
    },
      addExSource(post) {
              let params = {
              thread_id: this.$route.params.threadId,
              profile_id: post.owner_id,
              network_id: post.network_id,
            };

            addStopSourcesApi(params).then(resp => {
              this.$emit('updateSources', resp.data);

              this.excluded = post.id;
            });
            this.excluded = post.id;
      },
      getDate(dateTime) {
        let dateTimeArr = dateTime.split(' ');
        let dateArr = dateTimeArr[0].split('-');

        return dateTimeArr[1] ? dateArr[2] + '.' + dateArr[1] + '.' + dateArr[0].slice(2, dateArr[0].length) + ' ' + dateTimeArr[1] : dateArr[2] + '.' + dateArr[1] + '.' + dateArr[0].slice(2, dateArr[0].length);
      }
    }
  };
</script>

<style>
  .post-header {
    display: flex;
    justify-content: space-between;
  }

  .post-header--repost {
    border-top: 1px solid #ccc;
    padding-top: 20px;
    margin-top: 10px;
  }

  .copy-posts-wrap .post-info-panel__item{
    display: none;
  }

  .post-source,
  .post-source:hover,
  .post-source:visited,
  .post-source:active {
    text-decoration: none;
    color: inherit;
    display: flex;
  }
  .post-source__img-wrap {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 15px;
  }
  .post-source__img {
    display: inline-block;
    width: 100%;
  }
  .post-source__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .flex{
    display: flex;
    align-items: center;
  }

  .edit{
    padding: 0 5px;
    cursor: pointer;
  }

  .el-select-dropdown{
    max-width: 500px;
  }

  .post-source__title {
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 5px;
    text-decoration: none;
    color: inherit;
    display: block;
  }

  .post-source__date {
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 300;
    font-size: 10px;
    text-decoration: none;
    color: inherit;
    display: block;
  }
  .post-social-list {
    display: flex;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .post-social-list__item {
    display: flex;
    align-items: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 500;
    font-size: 12px;
    margin-right: 20px;
  }
  .post-social-list__item img {
    margin-right: 5px;
  }
  .post-social-list__item:last-child {
    margin-right: 0;
  }
  .wordfound {
    background-color: #ffcc00;
  }


  @media screen and (max-width: 480px) {
    .post-social-list__item {
      display: block;
    }
    .post-source__title{
      max-width: 180px;
    }
    .post-header {
      flex-wrap: wrap;
    }
    .post-social {
      width: 100%;
      margin-top: 10px;
    }
    .post-social-list__item {
      margin-bottom: 5px;
    }
  }
</style>
